import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f64b60a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "preview" }
const _hoisted_2 = { class: "preview_content" }
const _hoisted_3 = { class: "preview_content_box" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]

import { ref } from 'vue'
    import { Swiper, SwiperSlide } from 'swiper/vue'
    import 'swiper/css'
    import 'swiper/css/effect-cube'
    import 'swiper/css/pagination'

    
export default /*#__PURE__*/_defineComponent({
  props: {
        list: {
            type: Array,
            require: true
        },
        index: {
            type: Number,
            default: 0
        }
    },
  emits: [ 'close' ],
  setup(__props, { emit }) {

const props = __props

    

    let video: any = ref(null)

    

    // 关闭组件
    const closes = () => {
        emit('close')
    }

    // 切换暂停播放
    const onSlideChange = () => {
        if (!video.value) return
        video.value.forEach((item: any) => {
            item.pause()
        })
    }

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "preview_close",
      onClick: closes
    }, [
      _createVNode(_component_van_icon, {
        name: "cross",
        size: "20"
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Swiper), {
        onSlideChange: onSlideChange,
        initialSlide: props.index
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.list, (item, index) => {
            return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  (item.type === 0)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: item.url,
                        alt: ""
                      }, null, 8, _hoisted_4))
                    : (item.type === 1)
                      ? (_openBlock(), _createElementBlock("video", {
                          key: 1,
                          ref_for: true,
                          ref_key: "video",
                          ref: video,
                          src: item.url,
                          controls: "controls"
                        }, null, 8, _hoisted_5))
                      : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["initialSlide"])
    ])
  ]))
}
}

})